"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoutApiToken = void 0;
var Api_1 = require("@/api/remote/Api");
exports.logoutApiToken = function (token) {
    return Api_1.api().request({
        method: 'POST',
        url: 'account/logout',
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
